export const users: TableModule = {
    name: "users",
    route: "spa.settings.users",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    columns: [
        {
            name: "customName",
            sortable: true,
            pageLink: true,
            sortBy: "lastname|firstname",
            mobile: true,
            width: "w-auto"
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "phone",
            breakpoint: "lg",
        },
        {
            name: "organisation",
            breakpoint: "md",
        },
        {
            name: "last_login_at",
            width: "w-[150px]"
        },
    ],
    filters: [
        {
            name: "id",
            column: "users.id",
            type: "numeric",
            reduced: '[,]'
        },
        {
            name: "firstname",
            column: "users.firstname",
            type: "string"
        },
        {
            name: "email",
            column: "users.email",
            type: "string",
            reduced: 'like'
        },
        {
            name: "organisation",
            column: "name",
            relation: "organisations",
            type: "string"
        }
    ],
    quickFilters: [
        {
            name: "qf_onlyEmployees",
            column: "role_name",
            relation: "organisationUsers",
            value: "user",
            operator: "="
        }
    ],
    tools: [
        // {
        //     name: "users.delete",
        //     color: "rose",
        //     icon: "heroicons:trash"
        // },
        {
            name: "users.create",
            isCreateAction: true,
            ability: [
                "create",
                "users"
            ]
        }, {
            name: "general.export",
            ability: ["create", "users"]
        }
    ]
}